import React, { useMemo } from 'react';
import AppCustomIcon, {
	AppIconDashboard,
	AppIconDocuments,
	AppIconFaq,
	AppIconInvestments,
} from '../../../app/features/icon/AppIcon';
import langUserNavigation from '../langs/langUserNavigation';
import investmentTypeLang from '../../investor/features/fund-type/langs/investmentTypeLang';
import _ from 'lodash';
import IAppNavigation from '../../../app/features/navigation/interfaces/IAppNavigation';
import useInvestDashboardKpis from '@/apps/investor/hooks/dashboard/useInvestDashboardKpis';

const useUserMenu = () => {
	const investmentNavigation = useMemo(
		() =>
			[
				{
					id: 'investment_dashboard',
					routeTag: 'investment_dashboard',
					routeParams: null,
					routeGet: null,
					title: langUserNavigation.dashboard.tag,
					type: 'item',
					icon: <AppIconDashboard />,
					children: null,
				},
				{
					id: 'investment_types',
					routeTag: null,
					routeParams: null,
					routeGet: null,
					title: langUserNavigation.investments.tag,
					type: 'collapse',
					icon: <AppIconInvestments />,
					children: [
						{
							id: 'investments_types_private_credit',
							routeTag: 'investment_fund_type',
							routeParams: { investExpertiseTag: 'private_credit' },
							routeGet: null,
							title: investmentTypeLang.private_credit.tag,
							type: 'item',
							icon: null,
							children: null,
						},
						{
							id: 'investments_types_real_estate',
							routeTag: 'investment_fund_type',
							routeParams: { investExpertiseTag: 'real_estate' },
							routeGet: null,
							title: investmentTypeLang.real_estate.tag,
							type: 'item',
							icon: null,
							children: null,
						},
						{
							id: 'investments_types_listed_assets',
							routeTag: 'investment_fund_type',
							routeParams: { investExpertiseTag: 'listed_assets' },
							routeGet: null,
							title: investmentTypeLang.listed_assets.tag,
							type: 'item',
							icon: null,
							children: null,
						},
					],
				},
				{
					id: 'documents',
					routeTag: 'documents_dashboard',
					routeParams: null,
					routeGet: null,
					title: 'user.navigation.documents',
					type: 'item',
					icon: <AppIconDocuments />,
					children: [],
				},
				{
					id: 'news_articles',
					routeTag: 'news_articles',
					routeParams: null,
					routeGet: null,
					title: 'user.navigation.news',
					type: 'item',
					icon: <AppCustomIcon tag="news" color="secondary" />,
					children: null,
				},
				{
					id: 'faq_investor',
					routeTag: 'faq_investor',
					routeParams: null,
					routeGet: null,
					title: 'user.navigation.faq',
					type: 'item',
					icon: <AppIconFaq />,
					children: null,
				},
			] as unknown as IAppNavigation[],
		[],
	);

	const { fundTypes } = useInvestDashboardKpis();

	return useMemo(() => {
		// MAJ du menu de navigation à partir de la liste des fonds
		if (!fundTypes) return null;
		const sortedFundTypes = _.sortBy(fundTypes, (x) => -x.committedCapital);
		const newChildren: IAppNavigation[] = sortedFundTypes.map((fundType) => ({
			id: `investments_types_${fundType.tag}`,
			routeTag: 'investment_fund_type',
			routeParams: { investExpertiseTag: fundType.tag },
			routeGet: null,
			title:
				(investmentTypeLang as Record<string, { tag: string } | undefined>)[fundType.tag]?.tag ?? fundType.tag,
			type: 'item',
			icon: null,
			children: null,
			visible: true,
		}));
		// Shallow copy: avoid cloneDeep which would deep-clone JSX icons (expensive).
		return investmentNavigation.map((item) =>
			item.id === 'investment_types' ? { ...item, children: newChildren } : item,
		);
	}, [investmentNavigation, fundTypes]);
};

export default useUserMenu;
